import {
    Activity,
    Bone,
    Brain,
    Dumbbell,
    HeartHandshake,
    Baby,
    Zap,
    Waves,
    HeartPulse,
    Hand,
    Sparkles,
    Phone,
    MapPin,
    Clock,
    Menu,
    X,
    Check,
    Globe,
    Instagram,
    Facebook,
    Mail,
    ArrowLeft,
    ChevronDown,
    CalendarDays,
    ClipboardList,
    Clock3,
    Compass,
    HelpCircle,
    Images,
    MessageCircle,
    Stethoscope,
    Users,
    Wrench,
    Star,
} from "lucide-react";

const base = "h-5 w-5 shrink-0";

export const serviceIcons = {
    activity: Activity,
    bone: Bone,
    brain: Brain,
    dumbbell: Dumbbell,
    heartHandshake: HeartHandshake,
    baby: Baby,
    zap: Zap,
    waves: Waves,
    heartPulse: HeartPulse,
    hand: Hand,
    sparkles: Sparkles,
};

export const ServiceIcon = ({ name, className = "h-6 w-6" }) => {
    const Cmp = serviceIcons[name] || Activity;
    return <Cmp className={className} strokeWidth={1.75} aria-hidden="true" />;
};

export const IconPhone = ({ className = base }) => <Phone className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconPin = ({ className = base }) => <MapPin className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconClock = ({ className = base }) => <Clock className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconMenu = ({ className = "h-6 w-6" }) => <Menu className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconClose = ({ className = "h-6 w-6" }) => <X className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconCheck = ({ className = base }) => <Check className={className} strokeWidth={2.25} aria-hidden="true" />;
export const IconGlobe = ({ className = base }) => <Globe className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconInstagram = ({ className = base }) => <Instagram className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconFacebook = ({ className = base }) => <Facebook className={className} strokeWidth={1.75} aria-hidden="true" />;
export const IconMail = ({ className = base }) => <Mail className={className} strokeWidth={1.75} aria-hidden="true" />;

export const IconArrow = ({ className = base, direction = "forward" }) => (
    <ArrowLeft
        className={`${className} ${direction === "backward" ? "ltr:rotate-0 rtl:rotate-180" : "ltr:rotate-180"}`}
        strokeWidth={1.75}
        aria-hidden="true"
    />
);

export const IconChevronDown = ({ className = "h-3.5 w-3.5" }) => <ChevronDown className={className} strokeWidth={1.75} aria-hidden="true" />;

const navIcons = {
    care: Stethoscope,
    about: Compass,
    stories: MessageCircle,
    visit: CalendarDays,
    services: ClipboardList,
    approach: HeartPulse,
    equipment: Wrench,
    why: Compass,
    women: Users,
    team: Users,
    reviews: Star,
    success: MessageCircle,
    hours: Clock3,
    faq: HelpCircle,
    gallery: Images,
    contact: MessageCircle,
};

export const IconNav = ({ name, className = "h-4 w-4" }) => {
    const Cmp = navIcons[name] || Compass;
    return <Cmp className={className} strokeWidth={1.75} aria-hidden="true" />;
};

export const IconStar = ({ className = "h-4 w-4" }) => (
    <Star className={className} fill="currentColor" strokeWidth={0} aria-hidden="true" />
);
export const IconGoogle = ({ className = base }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z" />
    </svg>
);

export const IconWhatsApp = ({ className = base }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
);
